import { Img } from "containers/Manual/components/content/Image";
import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { Li } from "containers/Manual/components/list/Li";
import { Ul } from "containers/Manual/components/list/Ul";
import { CardSection } from "containers/Manual/components/section/CardSection";
import { ListSection } from "containers/Manual/components/section/ListSection";

export const MONTH = () => {
  return (
    <CardSection id="MONTH" title="MONTH">
      <Paragraph>날짜/시간 객체에서 월을 추출합니다.</Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>MONTH(DATETIME)</Paragraph>
        <Ul>
          <Li>
            <b>DATETIME</b>은 월을 추출하려는 날짜입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>MONTH(`DATE`)</Paragraph>
        <Img src="computeMonth" />
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          <b>DATETIME</b>은 날짜/시간 객체, 날짜/시간 객체를 포함하는 열 또는
          날짜/시간 객체를 반환하는 함수여야 합니다.
        </Paragraph>
        <Paragraph>반환되는 값의 범위는 1(1월)에서 12(12월)입니다.</Paragraph>
      </ListSection>
    </CardSection>
  );
};
